import { useMutation, useQueryClient } from '@tanstack/react-query';
import { onboardUser, OnboardUserRequest } from '../api/userManagementApi';
import { onboardingKeys } from '../../onboarding/hooks/onboardingKeys';
import { userKeys } from './userKeys';

/**
 * Mutation hook for inviting a user.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useInviteUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: {
      email: string;
      role: number | null;
      isBookingWork: boolean;
    }) => {
      if (request.role === null) {
        throw new Error('A role must be selected');
      }

      const payload: OnboardUserRequest = {
        email: request.email,
        role: request.role,
        isBookingWork: request.isBookingWork,
      };

      return onboardUser(payload);
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.lists() });
      queryClient.invalidateQueries({ queryKey: userKeys.all });
      queryClient.invalidateQueries({ queryKey: onboardingKeys.status() });
    },
  });
}
